const allLocales = require('../../../data/locales.json')

const defaultLanguageSelector = [
  {
    "locale": "fr",
    "slug": ""
  },
  {
    "locale": "en",
    "slug": ""
  }
]

// Add localization and directories to slugs
export function localizePath(pageContext, postType, pageDirectories) {
  const { locale, slug } = pageContext
  if (slug !== null && slug !== undefined) {
    if (postType && postType !== 'pages' && postType !== 'landingPages') {
      let postDir = ''
      if (pageDirectories) {
        pageDirectories.forEach((dir) => {
          const dirLocale = dir.node.locale
          const dirSlugs = dir.node.slugs
          if (dirLocale === locale) {
            let dirID = postType.replace('-', '_')
            postDir = dirSlugs[dirID] !== undefined ? `/${dirSlugs[dirID]}` : ''
          }
        })
      }
      if (locale === 'en') {
        return `${postDir}/${slug}`
      }
      return `/${locale.toLowerCase()}${postDir}/${slug}`
    }
    if (locale === 'en') {
      return `/${slug}`
    }
    return `/${locale.toLowerCase()}/${slug}`
  } else {
    if (locale === 'en') {
      return `/`
    }
    return `/${locale.toLowerCase()}`
  }
}

// Add the locale full name (since Strapi doesn't send this info...)
export function localizationName(locale) {
  let languageName = ''
  {
    allLocales.map((data) => {
      if (data.code === locale) {
        languageName = { name: data.nativeName, enName: data.name }
      }
    })
  }
  return languageName
}

// List all available slugs for a given page (to populate language switcher)
export async function listLocalizedPaths(pageContext, postType, pageDirectories, localeSlugs) {
  // If empty, replace by links to home page
  if (localeSlugs.length === 0) {
    localeSlugs.attributes = defaultLanguageSelector
  }

  const languageName = localizationName(pageContext.locale)
  const currentPage = {
    locale: pageContext.locale,
    name: languageName.name,
    href: localizePath(pageContext, postType, pageDirectories)
  }

  const paths = await Promise.all(
    localeSlugs.map(async localization => {
      const localePage = localization.attributes ? localization.attributes : localization
      const publicationDate = localePage.publishedAt ? localePage.publishedAt : localePage.published_at ? localePage.published_at : null
      const languageName = localizationName(localePage.locale)
      return {
        locale: localePage.locale.toLowerCase(),
        name: languageName.name,
        enName: languageName.enName ? languageName.enName : null,
        href: localizePath(localePage, postType, pageDirectories, pageContext),
        published: publicationDate !== null ? true : false
      }
    })
  )

  const localizedPaths = [currentPage, ...paths]

  // Reorder locales alphabetically
  localizedPaths.sort((a, b) => a.locale.localeCompare(b.locale))

  // Check the default locale is first
  const defaultLocaleIndex = localizedPaths.findIndex(
    path => path.locale === pageContext.defaultLocale
  )

  if (defaultLocaleIndex !== 0) {
    // Grab the default locale by mutating the localizedPaths array
    const [defaultLoc] = localizedPaths.splice(defaultLocaleIndex, 1)
    // Add it back to the front of the array
    localizedPaths.unshift(defaultLoc)
  }

  return localizedPaths
}
